export const MOBILE_DESCRIPTION_LENGTH = 60;
export const APP_STORE_DOWNLOAD_URL = "https://apps.apple.com/in/app/todaywithgod/id6476399543";
export const PLAY_STORE_DOWNLOAD_URL = "https://play.google.com/store/apps/details?id=com.twg";
